import axios from 'axios';

const apiBaseURL = window.APP_CONFIG.API_BASE_URL;
const publicClient = axios.create({ baseURL: `${apiBaseURL}/api`, timeout: 5000 });

export const fetchProfile = (language = 'en') => publicClient
  .get('/profile', { params: { lang: language } })
  .then((response) => {
    if (response.data?.code !== 200) {
      throw new Error(response.data?.message || 'Could not load the site profile.');
    }
    return response.data.data;
  });
